export const IMAGE_SEGMENT_FILL = "rgba(255, 255, 255, 0.8)";
export const VIDEO_SEGMENT_FILL = "rgb(255, 255, 255)";
export const VIDEO_INACTIVE_FILL = "rgb(244, 244, 246)";
export const IMAGE_INACTIVE_OPACITY = "0.5";
export const VIDEO_INACTIVE_OPACITY = "1";
